import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Login from "../pages/Login";
import Dashboard from "../pages/Dashboard";
import ActivateUser from "../pages/ActivateUsers";
import PrivateRoute from "../components/PrivateRoute";
import AdminLayout from "../layout/AdminLayout";
import ManageUsers from "../pages/ManageUsers";
import Orders from "../pages/Orders";
import Privacy from "../pages/privacy";
import Terms from "../pages/terms";

const Navigation = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />

        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <AdminLayout>
                <Dashboard />
              </AdminLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/activate-users"
          element={
            <PrivateRoute>
              <AdminLayout>
                <ActivateUser />
              </AdminLayout>
            </PrivateRoute>
          }
        />

        <Route
        path="/manage-users"
        element={
          <PrivateRoute>
            <AdminLayout>
              <ManageUsers />
            </AdminLayout>
          </PrivateRoute>
        }
        />

         <Route
        path="/Orders"
        element={
          <PrivateRoute>
            <AdminLayout>
              <Orders />
            </AdminLayout>
          </PrivateRoute>
        }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default Navigation;
